module.exports = __webpack_public_path__ + "img/4image-5.b2e52a33.png";